// file: toggleSwitch.jsx
import React, { useState } from "react";
import styles from "./ToggleSwitch.module.scss";
import OrderModal from "../orderModal/OrderModal";
import { useDispatch } from "react-redux";
import {
  createShipment,
  updateOrderStatusByCartBundleId,
} from "../../../store/actions";
import { useNavigate } from "react-router-dom";

const ToggleSwitch = ({ value, cartBundleId, status, cartBundleData }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isOn, setIsOn] = useState(false);

  const handleToggle = (val) => {
    setIsOn(val);
  };

  const handleUpdate = () => {
    console.log("yes it is clicked");
    const statusId = value === "packager" ? 1 : status === 1 ? 2 : 3;
    dispatch(
      updateOrderStatusByCartBundleId({
        id: cartBundleId,
        status: statusId,
        callback: {
          success: (data) => {
            if (statusId === 1) {
              dispatch(
                createShipment({
                  cartBundleId: cartBundleId,
                  addressId: cartBundleData?.address?.id,
                  callback: {
                    success: () => navigate("/cartBundleOrdersPackager"),
                  },
                })
              );
            }
            navigate("/cartBundleOrdersPackager");
            handleToggle(false);
          },
        },
      })
    );
  };

  console.log("Status", status);

  return (
    <div className={styles.container}>
      <span className={styles.label}>Status :</span>
      <div className={styles.wrapper} onClick={() => handleToggle(true)}>
        <div className={`${styles.switch} ${isOn ? styles.active : ""}`}>
          <div className={styles.knob}></div>
        </div>
      </div>
      <span className={styles.statusText}>
        {value === "packager" ? "Pack" : status === 1 ? "Ship" : "Delivered"}
      </span>
      {isOn && (
        <OrderModal
          handleToggle={handleToggle}
          value={value}
          handleUpdate={handleUpdate}
          status={status}
        />
      )}
    </div>
  );
};

export default ToggleSwitch;
